import TermsAndPrivacy from './TermsAndPrivacy'

export default TermsAndPrivacy
